import { useCallback, useId } from 'react';
import { useGetCurrentBusinessId } from '@/modules/common/hooks/useGetCurrentBusinessId.ts';
import { useCurrentUserFormsListQuery } from '@/modules/admin-dashboard/queries/forms.ts';
import { SelectPaginate, SelectPaginateOption } from 'ui';

type baseProps = {
  label?: string;
  formFieldTitle: string;
  error?: string;
  disabled?: boolean;
  className?: string;
  isClearable?: boolean;
  placeholder?: string;
};

type singleProps = {
  isMulti: false;
  onChange: (options: SelectPaginateOption<number>, title: string) => void;
  defaultValue?: SelectPaginateOption<number>;
  value?: SelectPaginateOption<number> | null;
};

type multiProps = {
  isMulti: true;
  onChange: (options: SelectPaginateOption<number>[], title: string) => void;
  defaultValue?: SelectPaginateOption<number>[];
  value?: SelectPaginateOption<number>[];
};

type FormSelectPaginateProps = baseProps & (singleProps | multiProps);

const FormSelectPaginate = ({
  label,
  error,
  value,
  isMulti,
  className,
  disabled,
  placeholder,
  isClearable,
  defaultValue,
  formFieldTitle,
  onChange,
}: FormSelectPaginateProps) => {
  const businessId = useGetCurrentBusinessId();
  const { fetchNextPage } = useCurrentUserFormsListQuery(
    { page: 1, page_size: 15, filter_by_name: '' },
    { disabled: true, cacheKey: useId() },
  );

  const handleAsyncLoadFormOptions = useCallback(
    async (page: number, search?: string) => {
      const formsData = await fetchNextPage({ pageParam: { page, search } });

      const forms = formsData?.data?.pages?.at(-1)?.data || [];
      return forms.map(({ id, name }) => ({
        label: name,
        value: id,
      }));
    },
    [fetchNextPage],
  );
  return (
    <SelectPaginate
      disabled={disabled}
      cacheUniqs={[businessId]}
      isMulti={isMulti}
      label={label}
      className={className}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onAsync={handleAsyncLoadFormOptions}
      onChange={options => onChange(options as any, formFieldTitle)}
      error={error}
      value={value}
      isClearable={isClearable}
    />
  );
};

export default FormSelectPaginate;
